import { axiosRetry } from './axiosRetryInstance';

// Browsers set File.type to "" for types they don't recognise (HEIC on Windows, DNG, MSG). The API refuses a blank
// content type, and the presigned URL is signed for the type sent at presign time, so both requests must use this.
export const OCTET_STREAM_CONTENT_TYPE = 'application/octet-stream';

export const getUploadContentType = (file: File): string => file.type || OCTET_STREAM_CONTENT_TYPE;

export const awsPresignedUpload = async (file: File, presignedUrl: string) => {
    try {
        const arrayBuffer = await file.arrayBuffer();
        const blob = new Blob([new Uint8Array(arrayBuffer)]);

        const axiosResponse = await axiosRetry.put(presignedUrl, blob, {
            headers: {
                'Content-Type': getUploadContentType(file),
            },
        });

        return axiosResponse;
    } catch (e) {
        console.error(e);
    }
};
